// firebaseConfigNotification.js (NOTIFICATIONS ONLY)
import { initializeApp, getApps } from "firebase/app";
import { isSupported, getMessaging, getToken, onMessage } from "firebase/messaging";
// (اختياري) analytics بس على المتصفح وبحذر
// import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";

const notifConfig = {
  apiKey: "AIzaSyDJc991-9r8ixYtMdtARIJcl85xsSRRlxY",
  authDomain: "partech-3259c.firebaseapp.com",
  projectId: "partech-3259c",
  storageBucket: "partech-3259c.firebasestorage.app",
  messagingSenderId: "284098642864",
  appId: "1:284098642864:web:40e1a2ca760c5da8b54c75",
  measurementId: "G-X1H7WJTZZE",
};

// أنشئ secondary app مرة واحدة
export const notifApp =
  getApps().find(a => a.name === "secondaryApp") ??
  initializeApp(notifConfig, "secondaryApp");

// كشف in-app browsers (إنستغرام/تيك توك/FB…)
function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /(FBAN|FBAV|Instagram|Line|Twitter|TikTok|WKWebView)/i.test(ua);
}

// استدعِ هذه الدالة فقط على الـ client (داخل useEffect مثلًا)
export async function initNotifications(vapidKey) {
  try {
    if (typeof window === "undefined") return { supported: false }; // SSR
    if (isInAppBrowser()) return { supported: false }; // iOS in-app لا تدعم

    const supported = await isSupported();
    if (!supported) return { supported: false };

    // مهم: ملف SW في جذر الدومين تمامًا
    const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
      type: "module",
      scope: "/",
    });

    const messaging = getMessaging(notifApp);
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swReg,
    });

    // رسائل foreground (اختياري)
    onMessage(messaging, (payload) => {
      // اعرض Toast أو حدّث الواجهة
    });

    return { supported: true, token: token || null };
  } catch (err) {
    // try/catch فقط كـ fallback لعدم كسر الصفحة
    console.warn("FCM init skipped:", err);
    return { supported: false, error: err };
  }
}
